export enum SupplementalMaterialsStatus {
	None = 0,
	AutoSupplementalMaterials = 1,
	ManualSupplementalMaterials = 2,
	SupplementalMaterialsOrderCanceled = 3,
	SupplementalMaterialsOrderInProgress = 4,
	ManualSupplementalMaterialRequestAvailable = 5,
	ServerRequestInProgress = 6
}
